// Shared types + constants for the Base QA Manager surface (BaseQAManager,
// BaseQAPackageCard, BaseQAPackageForm). Split out so the card/form modules
// don't need to import from BaseQAManager.tsx (which would otherwise be the
// only source for these types).

export interface QARule {
  id: number;
  rule: string;
  instructions: string;
  order: number;
}

export interface QAPackage {
  id: number;
  name: string;
  description: string;
  instructions: string;
  package_type: PackageTypeValue;
  is_globally_disabled: boolean;
  payor_types: string[];
  report_types: string[];
  rules: QARule[];
}

export interface ApiListResponse<T> {
  count: number;
  results: T[];
}

export interface ApiResponse<T> {
  data: T;
  status: number;
}

export const PackageType = {
  BASE: "base",
  INSURANCE: "insurance",
} as const;

export type PackageTypeValue = (typeof PackageType)[keyof typeof PackageType];
